import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './BillingMethodItem.m.sass';
import { match } from '../../../../utils/patternMatchUtil';
import Icon from '../../../../components/Icon';
import IconButton from '../../../../components/IconButton';
import { Dropdown, DropdownItem, DropdownItemIcon } from '../../../../components/Dropdown';
import { BillingItem, Label, Content, Title, Description, Actions, ItemIcon } from '../../BillingItem';
import formatCurrency from 'utils/formatCurrency';
import RequirePerms from '../../../../iam/containers/RequirePerms';
import round from 'lodash';
var BillingMethodItem = function BillingMethodItem(_ref) {
  var method = _ref.method,
    onClick = _ref.onClick,
    workspace = _ref.workspace,
    allowEdit = _ref.allowEdit,
    billingStore = _ref.billingStore,
    sessionStore = _ref.sessionStore,
    state = _ref.state,
    checkout = _ref.checkout;
  var busy = billingStore.busy;
  var disabled = busy;
  return /*#__PURE__*/React.createElement(BillingItem, {
    checkout: checkout,
    selected: method.default,
    disabled: disabled,
    onClick: onClick
  }, renderContentForMethod(method, workspace), method.default && (checkout ? /*#__PURE__*/React.createElement(Label, {
    checkout: true
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "check"
  }), " Selected") : /*#__PURE__*/React.createElement(Label, null, "Current")), /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(Dropdown, {
    position: "right",
    button: function button(buttonProps) {
      return /*#__PURE__*/React.createElement(IconButton, _extends({
        disabled: disabled
      }, buttonProps), /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "more vert"
      }));
    }
  }, method.type === 'Credit' && (sessionStore.member.hasPermission('ADMIN_TEAM_BILLING_VIEW') ? /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || state.creditViewState.showTransactionModal(method.id);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "account_balance"
  })), "Account Summary") : /*#__PURE__*/React.createElement(RequirePerms, {
    anyOf: ['MANAGE_TEAM_BILLING'],
    subject: sessionStore.teamMembers.find(function (x) {
      return x.teamId === state.team.id;
    })
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || state.creditViewState.showTransactionModal(method.id);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "account_balance"
  })), "Account Summary"))), method.type === 'Credit' && /*#__PURE__*/React.createElement(RequirePerms, {
    anyOf: ['MANAGE_TEAM_BILLING'],
    subject: sessionStore.teamMembers.find(function (x) {
      return x.teamId === state.team.id;
    })
  }, /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || state.creditViewState.showDepositModal(method.id);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "attach_money"
  })), "Make A Payment")), method.type === 'Credit' && sessionStore.member.hasPermission('ADMIN_TEAM_BILLING_MANAGE') && /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: function onClick(e) {
      return e.stopPropagation() || state.creditViewState.showCreditAdminModal(method.id);
    }
  }, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "play for work"
  })), "Admin Panel"), (method.type !== 'Credit' || sessionStore.member.hasPermission('ADMIN_TEAM_BILLING_MANAGE')) && /*#__PURE__*/React.createElement(DropdownItem, {
    disabled: method.default,
    onClick: function onClick(e) {
      e.stopPropagation();
      billingStore.deleteBillingMethod(method);
    }
  }, method.default ? /*#__PURE__*/React.createElement("div", null, "Can't remove default payment method") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
    small: true,
    material: true,
    name: "delete"
  })), "Remove Payment Method")))));
};
export default observer(BillingMethodItem);
function renderContentForMethod(method, workspace) {
  switch (method.type) {
    case 'Stripe':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
        auto: true,
        material: true,
        name: "credit card"
      })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("strong", null, method.brand), " ending in", ' ', /*#__PURE__*/React.createElement("strong", null, method.last4)), /*#__PURE__*/React.createElement(Description, null, "Expires", ' ', /*#__PURE__*/React.createElement("strong", null, method.exp_month, "/", method.exp_year), "\xA0 \u2022 \xA0", /*#__PURE__*/React.createElement("span", {
        className: cx(styles.cvc, styles[method.cvc_check])
      }, "CVC check", ' ', match(method.cvc_check, _defineProperty({
        pass: 'passed',
        fail: 'failed',
        unavailable: 'unavailable',
        unchecked: 'unchecked'
      }, match.DEFAULT, 'unavailable'))))));
    case 'Credit':
      {
        var balance = method.balance ? round(method.balance / 100, 2) : 0;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
          auto: true,
          material: true,
          name: "account balance"
        })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("strong", null, "Taxfyle Credit")), /*#__PURE__*/React.createElement(Description, null, /*#__PURE__*/React.createElement("p", null, "Statement Balance:", ' ', balance >= 0 && /*#__PURE__*/React.createElement("span", {
          className: cx(styles.goodBalance)
        }, "+ ", formatCurrency(balance)), balance < 0 && /*#__PURE__*/React.createElement("span", {
          className: cx(styles.warningBalance)
        }, formatCurrency(balance)), "\xA0"), /*#__PURE__*/React.createElement("p", null, "Remaining Balance:", ' ', /*#__PURE__*/React.createElement("span", {
          className: cx(styles.remainingBalance)
        }, formatCurrency(balance + Math.round(parseFloat(method.limit / 100), 2)))))));
      }
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, "Unknown billing method type \"", method.type, "\""), /*#__PURE__*/React.createElement(Description, null, "Not sure what this is.")));
  }
}
//# sourceMappingURL=index.js.map
